import type { PreClaimsReasonResponse } from './api';

export const normalizePreClaimsReason = (
  list: PreClaimsReasonResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.reasonCodeDesc,
    value: row.reasonCode,
  }));
};
